<template>
  <div>
    <vs-row
      vs-w="16"
      vs-type="flex"
      vs-align="flex-start"
      vs-justify="left"
      v-for="({ name, quantity, isFree }, index) in bundle"
      v-bind:key="index"
    >
      <vs-col vs-w="4" v-if="!isFree">
        <p class="font-12">{{ quantity }} x {{ name }}</p>
      </vs-col>
    </vs-row>
    <p class="font-12 pt-4 pb-1 underline" v-if="freeItems.length">Free Items: </p>
    <vs-row
      vs-w="16"
      vs-type="flex"
      vs-align="flex-start"
      vs-justify="left"
      v-for="({ name, quantity }, index) in freeItems"
      v-bind:key="index"
    >
      <vs-col vs-w="4">
        <p class="font-12">{{ quantity }} x {{ name }}</p>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'BundleDetails',
  props: ['bundle'],
  computed: {
    freeItems() {
      if (!this.bundle || !this.bundle.length) return [];
      return this.bundle.filter(item => item.isFree);
    },
  },
};
</script>
<style>
p.font-12 {
  font-size: 10px;
}

p.font-8 {
  font-size: 8px;
}
</style>
